import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'


Vue.use(ElementUI, {
  size: 'small',
  //components: ['ElTable', 'ElDialog', 'ElButton'],
  zIndex: 9999
})

import '@/styles/fonts.css'
import './styles/global.scss'
if (typeof window !== 'undefined') {
  window.global = window
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')